import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import {
  COMPONENT_SPACING,
  SPACING,
} from "../../../../../utils/constants/designConstants";
import theme from "../../../../../theme";

export const KCATSection = ({ keyChallengesContent }) => {
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box sx={{ display: "flex", gap: 4, position: "relative" }}>
      <Box sx={{ flex: 1 }}>
        <Grid
          container
          spacing={
            isMdUp
              ? COMPONENT_SPACING.GRID_SPACING_LARGE
              : COMPONENT_SPACING.GRID_SPACING
          }
        >
          {(keyChallengesContent.sections || []).map(
            (section, sectionIndex) => (
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  md: sectionIndex === 2 ? 12 : 6,
                }}
                key={sectionIndex}
              >
                <Box sx={{ py: { xs: 2, md: 4 } }}>
                  <Box sx={{ mb: SPACING.SUBHEADING_BOTTOM }}>
                    <Typography
                      variant="subtitle3"
                      sx={{ color: "primary.brandSecondary" }}
                    >
                      {section.title}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    {(section.bullets || []).map((bullet, bulletIndex) => (
                      <Typography variant="body1" key={bulletIndex}>
                        {bullet}
                      </Typography>
                    ))}
                  </Box>
                </Box>
              </Grid>
            ),
          )}
          <Grid
            size={{
              xs: 12,
              sm: 12,
              md: 6,
            }}
          >
            <FurtherReadingContent
              furtherReading={keyChallengesContent.furtherReading}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

const FurtherReadingContent = ({ furtherReading }) => {
  if (furtherReading.length === 0) return <></>;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: { sm: "center", md: "flex-end" },
      }}
    >
      <Box
        sx={{
          backgroundColor: "primary.main",
          width: "100%",
          color: "primary.white",
          borderBottomLeftRadius: theme.borderRadius.xxxl,
          minHeight: { xs: "auto", md: 370 },
          display: "flex",
          justifyContent: { sm: "center", md: "flex-end" },
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            p: { xs: 2, md: 4 },
            width: "100%",
          }}
        >
          <Typography
            variant="subtitle3"
            component="subtitle3"
            sx={{ color: "primary.brandSecondary", mb: { xs: 1, md: 2 } }}
          >
            Further Reading
          </Typography>
          {furtherReading.map((item, index) => (
            <Typography
              variant="body1"
              key={index}
              sx={{ color: "primary.white" }}
            >
              {item}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
